import { ADD_SELECTED_FARE, SelectedFareAction, SLICE_SELECTED_FARES, SliceSelectedFaresAction } from './actions';
import { SelectedFare } from '../../../DesktopFlight/types';

export const selectedFaresReducer = (
	state: SelectedFare[] = [],
	action: SelectedFareAction | SliceSelectedFaresAction
) => {
	switch (action.type) {
		case ADD_SELECTED_FARE:
			return [...state, (action as SelectedFareAction).payload];

		case SLICE_SELECTED_FARES:
			return state.slice(0, (action as SliceSelectedFaresAction).payload);

		default:
			return state;
	}
};
